<template lang="pug">
  .layout-view
    controls-panel(
      @open-create="modals.showCreatePlanning = true")
    template(v-if="!isMobile")
      planning-table-row-skeleton(
        v-if="!loaded")
      planning-table(
        v-else-if="schedules.length"
        :schedules="schedules")
      planning-table-empty(
        v-else
        @open-create="modals.showCreatePlanning = true")
    template(v-else)
      planning-table-skeleton-mobile(
        v-if="!loaded")
      planning-table-mobile(
        v-else-if="schedules.length"
        :schedules="schedules")
      planning-table-empty(
        v-else
        @open-create="modals.showCreatePlanning = true")

    v-dialog(
      max-width="380"
      v-model="modals.showCreatePlanning")
      create-planning-modal(
        @close="modals.showCreatePlanning = false")
</template>

<script>
import { mapGetters } from 'vuex'

import adaptationMixin from '@/mixins/adaptation.mixin.js'

import ControlsPanel from './ControlsPanel'

import PlanningTable from './table/PlanningTable'
import PlanningTableEmpty from './table/PlanningTableEmpty'
import PlanningTableRowSkeleton from './table/PlanningTableRowSkeleton'

import PlanningTableMobile from './table/PlanningTableMobile'
import PlanningTableSkeletonMobile from './table/PlanningTableSkeletonMobile'

import CreatePlanningModal from './modals/CreatePlanningModal'

export default {
  name: 'Planning',

  mixins: [adaptationMixin],

  components: {
    ControlsPanel,
    CreatePlanningModal,
    PlanningTable,
    PlanningTableEmpty,
    PlanningTableRowSkeleton,
    PlanningTableMobile,
    PlanningTableSkeletonMobile
  },

  data: () => ({
    modals: {
      showCreatePlanning: false
    }
  }),

  computed: {
    ...mapGetters('animalfeed', [
      'schedules',
      'loaded'
    ])
  }
}
</script>
